import React from 'react'

export default function Social() {
  return (
    <div className="home__social">
        <a href="#submit" className="home__social-icon " target='_blank'>
            <i className="uil uil-instagram" style={{color:"DeepPink"}}></i>
        </a>
        <a href="#submit" className="home__social-icon " target='_blank'>
            <i class="uil uil-whatsapp-alt" style={{color:"LimeGreen"}}></i>
        </a>
        <a href="#submit" className="home__social-icon " target='_blank'>
           <i class="uil uil-facebook-f" style={{color:"blue"}}></i>
        </a>
        
        <a href="#submit" className="home__social-icon " target='_blank'>
            <i className="uil uil-twitter-alt" style={{color:"DodgerBlue"}}></i>
        </a>
            <a href="#submit" className="home__social-icon " target='_blank'>
            <i className="uil uil-github-alt" style={{color:"MidnightBlue"}}></i>
        </a>
    </div>
  )
}
